export const AUTH_LOGIN = "AUTH_LOGIN";
export const AUTH_PERMISSIONS = "AUTH_PERMISSIONS";
export const AUTH_LOGOUT = "AUTH_LOGOUT";

export const AUTH_RELOAD = "AUTH_RELOAD";
export const USER_INFO = "USER_INFO";
